import { CircularProgress, IconButton, Menu, MenuItem, Tooltip } from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import React from "react";
import { classNames } from "../classNames/classNames";

export function ThreeDotMenu({ className, closeOnClick: componentCloseOnClickProp, options, disabled }: ThreeDotMenu.Props): JSX.Element {
    const [isMenuOpen, setIsMenuOpen] = React.useState(false);
    const ref = React.useRef<HTMLButtonElement>(null);

    return (
        <>
            <IconButton
                ref={ref}
                className={classNames(`h-min items-start p-2`, className)}
                type="button"
                onClick={() => {
                    if (disabled) return;
                    setIsMenuOpen(!isMenuOpen);
                }}
                disabled={disabled}
            >
                <MoreVert />
            </IconButton>
            <Menu open={isMenuOpen} anchorEl={ref.current} onClose={() => setIsMenuOpen(false)}>
                {options.map(
                    (
                        { label, onClick, className, closeOnClick: closeOnClickProp, hidden, icon, tooltip, isLoading, disabled, ...props },
                        index
                    ) => {
                        const closeOnClick = closeOnClickProp ?? true;

                        return (
                            <Tooltip key={index} title={tooltip || ""}>
                                <MenuItem
                                    {...props}
                                    className={classNames(`flex gap-2`, className, {
                                        hidden,
                                        "pointer-events-none text-gray-400": disabled,
                                    })}
                                    onClick={async (e) => {
                                        if (disabled) return;
                                        await onClick?.(e);
                                        if (componentCloseOnClickProp || closeOnClick) setIsMenuOpen(false);
                                    }}
                                >
                                    {isLoading && <CircularProgress className="text-primary" color="inherit" size="15px" />}
                                    {icon && !isLoading ? icon : null}
                                    {label}
                                </MenuItem>
                            </Tooltip>
                        );
                    }
                )}
            </Menu>
        </>
    );
}

export namespace ThreeDotMenu {
    export interface IOption<Id = string> {
        id: Id;
        label: string;
        disabled?: boolean;
        hidden?: boolean;
        onClick?: (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
        closeOnClick?: boolean;
        className?: string;
        icon?: JSX.Element;
        tooltip?: string;
        isLoading?: boolean;
    }
    export interface Props<Id = string> {
        options: IOption<Id>[];
        className?: string;
        closeOnClick?: true;
        disabled?: boolean;
    }
}
